// ContactSection.js
import React from 'react';

const ContactSection = () => {
  return (
    <section id="contact" className="contact">
      <h2>Contact Us</h2>
      <p>We'd love to hear from you! Get in touch below!</p>
      <form>
        <label htmlFor="name">Name:</label>
        <input type="text" id="name" name="name" required />
        
        <label htmlFor="email">Email:</label>
        <input type="email" id="email" name="email" required />

        <label htmlFor="message">Message:</label>
        <textarea id="message" name="message" rows="4" required></textarea>

        <button type="submit">Send</button>
      </form>
    </section>
  );
};

export default ContactSection;
